module.exports = __webpack_public_path__ + "img/mail.4a84895c.svg";